import { render } from "./Spaces.vue?vue&type=template&id=790f09ec&scoped=true&ts=true"
import script from "./Spaces.vue?vue&type=script&lang=ts"
export * from "./Spaces.vue?vue&type=script&lang=ts"

import "./Spaces.vue?vue&type=style&index=0&id=790f09ec&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790f09ec"]])

export default __exports__